import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

const messages = defineMessages({
  title: {
    description: 'title for the advanced Search Placeholder',
    defaultMessage: 'No results match your criteria',
    id: 'DpAqnz',
  },
  description: {
    description: 'description for the advanced Search Placeholder',
    defaultMessage: 'Refining, or even removing, some of your criteria can broaden your results.',
    id: 'ttzgc+',
  },
});

const AdvancedSearchPlaceholder = () => {
  return (
    <ActionablePlaceholder description={<FormattedMessage {...messages.description} />} title={<FormattedMessage {...messages.title} />} />
  );
};

export default AdvancedSearchPlaceholder;
